import store from "@/store";

const Epp = () => import("@/views/ADMIN/Epp.vue");

// Jefes y Centro de costos solo existen con gestión de lotes. Las pestañas ya
// se ocultan (getter tab_componentes); esto cubre la entrada directa por URL.
const requiereGestionLotes = async (to, from, next) => {
  try {
    await store.dispatch("eppModule/ensureFormEpp");
  } catch (error) {
    console.error(error);
  }

  if (store.state.eppModule.formEpp?.has_lotes === true) return next();
  next({ name: "epp-Dashboard" });
};

// Automatización solo existe con las automatizaciones activadas en la
// configuración de EPP (Dashboard). La pestaña ya se oculta (getter
// tab_componentes); esto cubre la entrada directa por URL.
const requiereAutomatizaciones = async (to, from, next) => {
  await store.dispatch("eppModule/ensureConfiguracionEpp");

  if (store.getters["eppModule/automatizacionesActivas"]) return next();
  next({ name: "epp-Dashboard" });
};

// Cada pestaña exige que el rol del usuario en EPP la permita (getter
// eppModule/rutasEppPermitidas); si no, se va a la primera permitida. Las
// pestañas ya se ocultan; esto cubre la entrada directa por URL y /epp, que
// redirige al Dashboard. Recibe la guardia propia de la ruta, si tiene.
const segunRolEpp =
  (guardia) =>
  async (to, from, next) => {
    await store.dispatch("eppModule/ensurePerfilEncargado");
    const rutas = store.getters["eppModule/rutasEppPermitidas"];
    if (rutas && !rutas.includes(to.name)) return next({ name: rutas[0] });
    // Solo el superadministrador ve la pestaña Automatización: se lee la
    // configuración antes de pintar las pestañas para que no aparezca y se vaya
    if (!rutas) await store.dispatch("eppModule/ensureConfiguracionEpp");
    return guardia ? guardia(to, from, next) : next();
  };

export const eppList = {
  path: "/epp",
  name: "Epp",
  meta: { requiresAuth: true },
  component: Epp,
  redirect: { name: "epp-Dashboard" },
  children: [
    {
      path: "dashboard",
      name: "epp-Dashboard",
      beforeEnter: segunRolEpp(),
      meta: { requiresAuth: true },
      component: () => import("@/components/Epp/Dashboard/Dashboard.vue"),
    },
    {
      path: "solicitudes",
      name: "epp-Solicitudes",
      beforeEnter: segunRolEpp(),
      meta: { requiresAuth: true },
      component: () => import("@/components/Epp/Solicitudes/Solicitudes.vue"),
    },
    {
      path: "reportes",
      name: "epp-Reportes",
      beforeEnter: segunRolEpp(),
      meta: { requiresAuth: true },
      component: () => import("@/components/Epp/Reportes/Reportes.vue"),
    },
    {
      path: "epp",
      name: "epp-Epp",
      beforeEnter: segunRolEpp(),
      meta: { requiresAuth: true },
      component: () => import("@/components/Epp/Epp/Epp.vue"),
    },
    {
      path: "crear",
      name: "epp-crear",
      beforeEnter: segunRolEpp(),
      meta: { requiresAuth: true },
      component: () => import("@/components/Epp/Epp/EppAdd.vue"),
    },
    {
      path: "editar/:id",
      name: "epp-editar",
      beforeEnter: segunRolEpp(),
      meta: { requiresAuth: true },
      component: () => import("@/components/Epp/Epp/EppAdd.vue"),
    },
    {
      path: "bodegas",
      name: "epp-Bodegas",
      beforeEnter: segunRolEpp(),
      meta: { requiresAuth: true },
      component: () => import("@/components/Epp/Bodegas/Bodegas.vue"),
    },
    {
      path: "encargados",
      name: "epp-Encargados",
      beforeEnter: segunRolEpp(),
      meta: { requiresAuth: true },
      component: () => import("@/components/Epp/Encargados/Encargados.vue"),
    },
    {
      path: "jefes",
      name: "epp-Jefes",
      meta: { requiresAuth: true },
      beforeEnter: segunRolEpp(requiereGestionLotes),
      component: () => import("@/components/Epp/Jefes/Jefes.vue"),
    },
    {
      path: "centrodecostos",
      name: "epp-CentroDeCostos",
      meta: { requiresAuth: true },
      beforeEnter: segunRolEpp(requiereGestionLotes),
      component: () => import("@/components/Epp/CentroDeCostos/CentroDeCostos.vue"),
    },
    {
      path: "automatizacion",
      name: "epp-Automatizacion",
      beforeEnter: segunRolEpp(requiereAutomatizaciones),
      meta: { requiresAuth: true },
      component: () => import("@/components/Epp/Automatizacion/Automatizacion.vue"),
    }
  ],
};
